/* Copyright (c) 2018 Verge Technologies
 * @file articleCard.js
 * @author Brenton Watt
 * @description Card component for applications for Seperations
 */

import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const ArticleCard = (props) => {
  return (
    <li>
      <div className="image-block">
        <img className="landscape" src={props.image} alt="article" />
      </div>
      <div className="content-block">
        <h2>{props.title}</h2>
        <p>
          {props.blurb}
        </p>
      </div>
      <div className="control">
        <Link to={`articles/${props.slug}`} className="button button-green">
          Read more
        </Link>
      </div>
    </li>
  );
};

ArticleCard.propTypes = {
  title: PropTypes.string.isRequired,
  blurb: PropTypes.string,
  slug: PropTypes.string.isRequired,
  image: PropTypes.string,
};

ArticleCard.defaultProps = {
  blurb: '',
  image: '',
};

export default ArticleCard;



// WEBPACK FOOTER //
// ./src/components/ArticleCard/articleCard.js